import {
    selectAccessToken,
    selectCompanyId,
    selectPermissions,
    selectRefreshToken,
    selectRole,
    selectSessionId,
} from 'store/auth-slice';
import { useAppSelector } from '../app/hooks';

export const useAuth = () => {
    const accessToken = useAppSelector(selectAccessToken);
    const refreshToken = useAppSelector(selectRefreshToken);
    const role = useAppSelector(selectRole);
    const permissions = useAppSelector(selectPermissions);
    const companyId = useAppSelector(selectCompanyId);
    const sessionId = useAppSelector(selectSessionId);

    return { accessToken, refreshToken, role, permissions, companyId, sessionId };
};
